<div class="login-container d-flex align-items-center justify-content-center min-vh-100">

  <div class="login-card d-flex rounded">
    <!-- Panel Izquierdo: Bienvenida -->
    <div class="left-panel d-flex flex-column justify-content-center align-items-center p-5 text-white">
      <img src="assets/img/brand/logo_jamar_rojo.svg" alt="Logo Jamar">
      <h1 class="fw-bold mb-2">¡Bienvenidos a NOVA!</h1>
      <p>La plataforma donde encontrarás todas las aplicaciones de nuestra organización de manera centralizada.</p>
      <p>NOVA (Núcleo Operativo de Valor Administrativo) </p>
    </div>

    <!-- Panel Derecho: Formulario -->
    <div class="right-panel p-5 bg-white">

      <div class="text-center mb-4">
        <h3 class="fw-bold">Cambiar contraseña</h3>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit($event)" class="form-container">

        <div class="custom-input">
          <input [type]="hideNewPassword ? 'password' : 'text'"
                 placeholder="Nueva contraseña"
                 formControlName="newPassword"
                 maxlength="100"
                 (input)="onPasswordChange($any($event.target).value)"
                 required>
          <button type="button" class="icon-button" (click)="hideNewPassword = !hideNewPassword" aria-label="Mostrar/ocultar contraseña">
            <mat-icon class="input-icon">{{ hideNewPassword ? 'lock' : 'lock_open' }}</mat-icon>
          </button>
        </div>

        <div class="custom-input">
          <input [type]="hideConfirmPassword ? 'password' : 'text'"
                 placeholder="Confirmar contraseña"
                 formControlName="confirmPassword"
                 maxlength="100"
                 (input)="onConfirmPasswordChange($any($event.target).value)"
                 required>
          <button type="button" class="icon-button" (click)="hideConfirmPassword = !hideConfirmPassword" aria-label="Mostrar/ocultar contraseña">
            <mat-icon class="input-icon">{{ hideConfirmPassword ? 'lock' : 'lock_open' }}</mat-icon>
          </button>
        </div>

        <!-- Requisitos de contraseña -->
        <div class="requirements">
          <p class="req-title">Requisitos de la contraseña:</p>
          <ul>
            <li *ngFor="let req of requirements" [hidden]="!req.visible" [ngClass]="{'met': req.met, 'unmet': !req.met}">
              <mat-icon>{{ req.met ? 'check_circle' : 'cancel' }}</mat-icon>
              <span>{{ req.label }}</span>
            </li>
          </ul>
        </div>

        <button mat-flat-button color="primary" type="submit" class="w-100 mt-2"
                [disabled]="!allRequirementsMet || form.hasError('mismatch')">
          Cambiar contraseña
        </button>

      </form>

      <div class="text-center mt-3">
        <a (click)="goBack()"><small>Volver al inicio de sesión</small></a>
      </div>

    </div>
  </div>
</div>
